import Api from "../Helpers/Api";

class CoordinatorsService {
  getCoordinators() {
    return Api.get(`/coordenadores`);
  }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new CoordinatorsService();